import { render, staticRenderFns } from "./indexFour.vue?vue&type=template&id=5325dc1e&scoped=true"
import script from "./indexFour.vue?vue&type=script&lang=js"
export * from "./indexFour.vue?vue&type=script&lang=js"
import style0 from "./indexFour.vue?vue&type=style&index=0&id=5325dc1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5325dc1e",
  null
  
)

export default component.exports